import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DashboardPreferencesEntity } from '../../domain/entities/dashboard-preferences.entity';
import { DashboardWidgetDataEntity } from '../../domain/entities/dashboard-widget-data.entity';
import { DashboardWidgetEntity } from '../../domain/entities/dashboard-widget.entity';
import { DashboardTimeframe } from '../../domain/enums/dashboard-timeframe.enum';
import { DashboardApi } from '../api/dashboard.api';
import { UpdateDashboardPreferencesRequestDto } from '../dtos/update-dashboard-preferences-request.dto';
import { DashboardMapper } from '../mappers/dashboard.mapper';

@Injectable({ providedIn: 'root' })
export class DashboardRepository {
  private readonly _api = inject(DashboardApi);
  private readonly _mapper = inject(DashboardMapper);

  public getMe(): Observable<DashboardPreferencesEntity> {
    return this._api.getMe().pipe(map((dto) => this._mapper.toPreferences(dto)));
  }

  public getWidgets(): Observable<DashboardWidgetEntity[]> {
    return this._api.getWidgets().pipe(map((dtos) => this._mapper.toWidgetArray(dtos)));
  }

  public getWidgetData(
    widgetId: string,
    timeframe?: DashboardTimeframe,
  ): Observable<DashboardWidgetDataEntity> {
    return this._api
      .getWidgetData(widgetId, timeframe)
      .pipe(map((dto) => this._mapper.toWidgetData(dto)));
  }

  public updatePreferences(request: UpdateDashboardPreferencesRequestDto): Observable<void> {
    return this._api.updatePreferences(request);
  }
}
